<template>
    <p class="text-secondary block-headline w-100">
        <i :class="headlineIcon" class="fad"></i>{{ text }}
    </p>
</template>

<script>
export default {
    name: 'BlockHeading',
    props: {
        icon: {
            type: String,
        },
        text: {
            type: String,
        },
    },

    computed: {
        headlineIcon() {
            if (this.icon !== '' && this.icon !== undefined) {
                return 'fa-' + this.icon + ' mr-2';
            }
            return this.icon;
        },
    },
};
</script>

<style lang="scss">
.block-headline {
    font-size: 1.5rem;
    font-weight: bold;
}
</style>
